import { FC } from 'react'
import Paper from '@mui/material/Paper'
import format from 'date-fns/format'
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium'
import { TableToolbar } from 'src/components/ui'
import { DataLogger, DataLoggerCurrentData } from 'src/api'

const columns: GridColDef<AppDataLoggerReading>[] = [
  { field: 'name', headerName: 'Reading', flex: 1, sortable: false, disableColumnMenu: true },
  { field: 'value', headerName: 'Value', flex: 1, sortable: false, disableColumnMenu: true },
  {
    field: 'readingTime',
    headerName: 'Reading Time',
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
    valueFormatter: (params) => (params.value ? format(new Date(params.value as string), 'PPpp') : '')
  }
]
interface Props {
  dataLogger: DataLogger
}
export interface AppDataLoggerReading {
  name: string
  value: string | number | undefined
  readingTime: string | undefined
}
type GetReadingRow = (data: DataLoggerCurrentData) => AppDataLoggerReading
interface ReadingRows {
  temperatureF: GetReadingRow
  humidity: GetReadingRow
  dewpoint: GetReadingRow
  battery: GetReadingRow
}

const rows: ReadingRows = {
  temperatureF: (data) => {
    return {
      name: 'Temperature',
      value: data.temperatureF ? `${data.temperatureF}°F` : '-',
      readingTime: data.temperatureTime
    }
  },
  humidity: (data) => {
    return {
      name: 'Humidity',
      value: data.humidity ? `${data.humidity}%` : '-',
      readingTime: data.humidityTime
    }
  },
  dewpoint: (data) => {
    return {
      name: 'Dewpoint Deviation',
      value: data.dewpointDeviationF ? `${data.dewpointDeviationF}°F` : '-',
      readingTime: data.dewpointTime
    }
  },
  battery: (data) => {
    return {
      name: 'Battery Level',
      value: data.battery ? `${data.battery}%` : '-',
      readingTime: data.batteryTime
    }
  }
}

export const DataLoggerLastReadings: FC<Props> = ({ dataLogger }) => {
  if (!dataLogger) return null

  const data: AppDataLoggerReading[] = Object.values(rows).map((value: GetReadingRow) => value((dataLogger.currentData as DataLoggerCurrentData) || {}))

  return (
    <Paper sx={{ height: '400px' }}>
      <DataGridPremium<AppDataLoggerReading>
        pagination={false}
        autoHeight={false}
        disableRowSelectionOnClick
        rows={data}
        columns={columns}
        rowCount={data.length}
        getRowId={(row) => row.name}
        rowThreshold={2}
        columnThreshold={2}
        hideFooterPagination
        localeText={{
          columnMenuSortAsc: 'Sort A-Z',
          columnMenuSortDesc: 'Sort Z-A'
        }}
        slots={{
          toolbar: () => <TableToolbar exportedFileName={`${document.title}_last_readings`} />
        }}
        sx={{
          border: 'none',
          '& .MuiDataGrid-columnHeaderTitleContainerContent': {
            paddingLeft: '5px',
            overflow: 'visible'
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            whiteSpace: 'normal',
            lineHeight: 1,
            fontSize: '13px',
            fontWeight: 400,
            color: 'rgba(0, 0, 0, 0.6)',
            overflow: 'visible'
          }
        }}
      />
    </Paper>
  )
}
